module.exports = __webpack_public_path__ + "80872e917ea74581b635732f0edc6731.jpg";